import React, { useEffect } from "react";
import Sheet from "../ui/Sheet";
import useMediaQuery from "../ui/useMediaQuery";

function Item({ children, onClick, danger = false }) {
  return (
    <button type="button" role="menuitem" className={`rg-menu-item${danger ? " is-danger" : ""}`} onClick={onClick}>
      {children}
    </button>
  );
}

function Switch({ label, checked, onChange }) {
  return (
    <button
      type="button"
      role="menuitemcheckbox"
      aria-checked={checked}
      className="rg-menu-item"
      onClick={() => onChange(!checked)}
    >
      <span>{label}</span>
      <span className={`rg-switch${checked ? " is-on" : ""}`} aria-hidden="true" />
    </button>
  );
}

// The avatar menu. A bottom sheet on phones, a dropdown under the avatar on wider screens.
export default function AvatarMenu({
  open,
  onClose,
  userName,
  isGuest,
  darkMode,
  onToggleDark,
  onNewChat,
  onOpenTasks,
  onOpenLockIn,
  onOpenProfile,
  onClearChat,
  onLogout,
  onCreateAccount,
}) {
  const wide = useMediaQuery("(min-width: 768px)");

  // Run the action after closing so the menu never covers what the action opens.
  const act = (fn) => () => {
    onClose();
    fn();
  };

  useEffect(() => {
    if (!open || !wide) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, wide, onClose]);

  const list = isGuest ? (
    <div role="menu" aria-label="Account menu">
      <div className="rg-menu-who">
        <strong>Guest</strong>
        <small>Trying Rigby without an account</small>
      </div>
      <Item onClick={act(onCreateAccount)}>Create free account</Item>
      <Item danger onClick={act(onLogout)}>Log out</Item>
    </div>
  ) : (
    <div role="menu" aria-label="Account menu">
      <div className="rg-menu-who">
        <strong>{userName}</strong>
      </div>
      <Item onClick={act(onNewChat)}>New chat</Item>
      <Item onClick={act(onOpenTasks)}>My tasks</Item>
      <Item onClick={act(onOpenProfile)}>Profile</Item>
      <hr className="rg-menu-sep" />
      <Item onClick={act(onOpenLockIn)}>Lock-In</Item>
      <Switch label="Dark mode" checked={!!darkMode} onChange={() => onToggleDark()} />
      <Item onClick={act(onClearChat)}>Clear this chat</Item>
      <hr className="rg-menu-sep" />
      <Item danger onClick={act(onLogout)}>Log out</Item>
    </div>
  );

  if (wide) {
    if (!open) return null;
    return (
      <>
        <div className="rg-menu-backdrop" onClick={onClose} />
        <div className="rg-menu-pop">{list}</div>
      </>
    );
  }

  return (
    <Sheet open={open} onClose={onClose} label="Menu">
      <div className="rg-menu-sheet">{list}</div>
    </Sheet>
  );
}
